/**
 * Tax Terms Card: Used to house the logic and terminology for 2025 late joiners for the 2024 tax season.
 * This has various logic branches, detailed in this PRD
 */

import { DateTime } from 'luxon'
import { useReselector } from '@/utils/sharedHooks'
import { convertUtcToLocalDate } from '@/utils/dateHelpers'
import {
  TAX_ENTITY_TYPES,
  TAX_ENTITY_TYPES_TYPE,
} from '@/featuresV1/Taxes/taxConstants'
import { selectCurrentAnnualTaxDetails } from '@/featuresV1/Admin/AnnualTaxDetails/annualTaxDetails.selector'

import { Terms1040 } from './Terms1040'
import { Terms1120S } from './Terms1120S'

export const TaxTerms = ({
  taxEntityType,
  currentTaxYear,
}: {
  taxEntityType?: TAX_ENTITY_TYPES_TYPE | null
  currentTaxYear: string
}) => {
  const today = DateTime.now()
  const activeDetails = useReselector(selectCurrentAnnualTaxDetails)

  if (!activeDetails) return null

  const form1040LateJoinerFinalCutoffDate = convertUtcToLocalDate(
    activeDetails.form_1040_new_user_tax_cutoff_date
  )?.endOf('day')

  const form1120sLateJoinerFinalCutoffDate = convertUtcToLocalDate(
    activeDetails.form_1120_s_new_user_tax_cutoff_date
  )?.endOf('day')

  switch (taxEntityType) {
    case TAX_ENTITY_TYPES.form_1040:
      if (
        form1040LateJoinerFinalCutoffDate &&
        today <= form1040LateJoinerFinalCutoffDate
      ) {
        return <Terms1040 currentTaxYear={currentTaxYear} />
      } else {
        return null
      }

    case TAX_ENTITY_TYPES.form_1120_s:
      if (
        form1120sLateJoinerFinalCutoffDate &&
        today <= form1120sLateJoinerFinalCutoffDate
      ) {
        return <Terms1120S currentTaxYear={currentTaxYear} />
      } else {
        return null
      }

    default:
      return null
  }
}
